import { branch, renderNothing } from 'recompose'
import { locationSelector } from 'sfproxy/selectors'
import ServicesComponent from 'car-parks/components/services/Services'

const Services = ({ services }) => <ServicesComponent services={services} />

export default compose(
    connect(locationSelector),
    branch(({ services }) => Object.values(services).filter(Boolean).length === 0, renderNothing)
)(Services)
